export const HTML_BLANK_LINE = '<DIV><BR></DIV>';
export const PLAIN_TEXT_BLANK_LINE = '\r\n';
